enum Operator {
    SUBTRACT = '-',
    ADD = '+',
}

export default Operator;
